module.exports = __webpack_public_path__ + "static/ballgown-b9cb98db12e5d1a5cd00977f3791fe4d.png";